$(document).ready( function (){

});

function favToolShow(id) {
 let target = '#toolDetail'+ id;
 let style = $(target).css('display');
 var url = "/user_tools/"+ id;
 if (style == 'none') {
     style = 'table-row';
     $(target).html('').load(url, function () {
         turnOnTooltips();
     }).val();
 } else {
     style = 'none';
     $(target).html('');
 }
    $(target).css('display',style);
}